import {INTERVAL_UPDATE_DATA_SECONDS} from 'src/modules/updater/constants';

import timer from '@pb/kit-util-timer';

class UpdatesChecker {
    stopTimers: Record<string, () => void> = {};

    subscribe = (timerId: string, callback: () => void, interval: number = INTERVAL_UPDATE_DATA_SECONDS) => {
        this.stopTimers[timerId] = timer.subscribe(interval, callback);
    };
    unSubscribe = (timerId: string) => {
        if (this.stopTimers?.[timerId]) {
            this.stopTimers[timerId]();
        }
    };
}

export default UpdatesChecker;
